import type { QcSummary, RecordingMode } from "../api/types";
import { useIsDemo } from "../api/auth";
import { gateFailed, gateFailures, withoutMode } from "../lib/gate";

/** Loud, top-of-page warning for a recording that failed the QC gate: it has no value as
 * delivered, so someone has to understand why before deciding anything. */
export default function GateBanner({ qc, mode }: { qc: QcSummary | null | undefined; mode: RecordingMode }) {
  const demo = useIsDemo();
  if (!gateFailed(qc)) return null;
  const reasons = gateFailures(qc, mode).map((r) => (demo ? withoutMode(r) : r));
  return (
    <div className="gate-banner" role="alert">
      <div className="gate-banner-head">
        <span className="gate-banner-icon" aria-hidden>
          ⚠
        </span>
        <div>
          <strong>Failed the QC gate — this recording has no value as delivered.</strong>
          <p>
            Do not approve it as-is. Understand why it fails (below and in the QC metrics), then
            reject it or fix the cause upstream and reprocess.
          </p>
        </div>
      </div>
      <ul className="gate-banner-reasons">
        {reasons.map((r) => (
          <li key={r}>{r}</li>
        ))}
      </ul>
    </div>
  );
}
